import { getTop, scrollTo, getHeaderHeight } from '../functions';

export default class Anchor {
  constructor($element) {
    this.$element = $element;

    this.$element.addEventListener('click' , (e) => {
      e.preventDefault();
      this.onClick();
    })
  }

  onClick() {
    const id = this.$element.dataset.anchor;
    if (id) {
      const destination = document.querySelector(id);

      if (destination) {
        scrollTo({to: getTop(destination) - getHeaderHeight()});
      }
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/dom/Anchor.js